import type { ReactNode } from 'react';

export const WARNINGS_TAB = 'release-report-warnings' as const;
export const ALL_ISSUES_TAB = 'release-report-all-issues' as const;
export const DONE_TAB = 'release-report-done' as const;
export const IN_PROGRESS_TAB = 'release-report-in-progress' as const;
export const TODO_TAB = 'release-report-todo' as const;

export type VersionTabId =
	| typeof WARNINGS_TAB
	| typeof ALL_ISSUES_TAB
	| typeof DONE_TAB
	| typeof IN_PROGRESS_TAB
	| typeof TODO_TAB;

export type VersionTab = {
	label: ReactNode;
	content: ReactNode;
	id: VersionTabId;
};
